import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  MenuItem,
  TextField,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import DialogContentText from "@mui/material/DialogContentText";

const RenderStatus = (props) => {
  /* UseState */
  const [idEstatus, setIdEstatus] = useState(2);
  const [oldStatus, setOldStatus] = useState(2);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState(undefined);
  /* End UseState */

  useEffect(() => {
    if (props.Row) {
      const row = props.Row.row;
      if (row) {
        setIdEstatus(row.idEstatus);
        setOldStatus(row.idEstatus);
      }
    }
  }, [props]);

  /* Methods */
  const closeMessageConfirm = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setShowMessage(false);
  };
  const handleChangeEstatus = (event) => {
    console.log({event})
    event.preventDefault();
    if (event.target.value) {
      if (event.target.value !== oldStatus) {
        setIdEstatus(event.target.value);
        var mensaje = `“¿Está seguro que desea cambiar el estatus del ${
          props.FieldName
        } “${props.NameRow}” de “${
          oldStatus === 2 ? "Activo" : "Inactivo"
        }” a “${event.target.value === 2 ? "Activo" : "Inactivo"}”?`;
        if (event.target.value === 2) {
          setMessage(mensaje);
        } else if (event.target.value === 3) {
          mensaje += ` ${props.MessageWhenInactive}`;
          setMessage(mensaje);
        }
        setShowMessage(true);
      }
    }
  };
  /* End Methods */

  return (
    <Box
      noValidate
      component="form"
      className="p-2"
      sx={{ display: "flex", width: "100%" }}
    >
      <TextField
        size="small"
        select
        fullWidth
        id="selectEstatus"
        value={idEstatus}
        label="Estatus"
        disabled={!props.PermisoEditar}
        onChange={handleChangeEstatus}
      >
        <MenuItem id={2} value={2}>
          Activo
        </MenuItem>
        <MenuItem id={3} value={3}>
          Inactivo
        </MenuItem>
      </TextField>
      <Dialog
        open={showMessage}
        onClose={closeMessageConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Activar/Desactivar"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="message">{message}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              closeMessageConfirm();
              setIdEstatus(oldStatus);
            }}
            variant="contained"
            color="secondary"
            sx={{ color: "#fff" }}
          >
            CANCELAR
          </Button>
          <Button
            onClick={() => {
              closeMessageConfirm();
              setOldStatus(idEstatus)
              props.OnFinish(idEstatus);
            }}
            autoFocus
            variant="contained"
          >
            ACEPTAR
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default observer(RenderStatus);
